import { ImagePlus, X } from "lucide-react";
import { toast } from "sonner";
import { Step } from "./Step";
import { newKey } from "../../lib/format";

const MAX = 8;
const MAX_MB = 10;

export function PhotoUpload({ photos, setPhotos }) {
  const add = (fileList) => {
    const files = Array.from(fileList || []);
    const ok = files.filter((f) => f.type.startsWith("image/") && f.size <= MAX_MB * 1024 * 1024);
    if (ok.length < files.length) toast.error(`Only images under ${MAX_MB} MB are allowed`);
    const next = [...photos, ...ok.map((file) => ({ key: newKey(), file, url: URL.createObjectURL(file) }))];
    if (next.length > MAX) toast.error(`Maximum ${MAX} photos`);
    setPhotos(next.slice(0, MAX));
  };
  const remove = (p) => { URL.revokeObjectURL(p.url); setPhotos(photos.filter((x) => x.key !== p.key)); };

  return (
    <Step n="4" title="Photos of your cargo (optional)" hint={`Helps us give an accurate price. Up to ${MAX} photos, ${MAX_MB} MB each.`} testId="quote-step-photos">
      <div className="grid grid-cols-3 sm:grid-cols-5 gap-3">
        {photos.map((p) => (
          <div key={p.key} className="relative aspect-square rounded-sm overflow-hidden border border-slate-200 group" data-testid={`quote-photo-${p.key}`}>
            <img src={p.url} alt={p.file.name} className="w-full h-full object-cover" />
            <button type="button" onClick={() => remove(p)} className="absolute top-1 right-1 p-1 bg-white/90 rounded-sm text-slate-700 hover:text-red-600" data-testid={`quote-photo-remove-${p.key}`}><X className="h-3.5 w-3.5" /></button>
          </div>
        ))}
        {photos.length < MAX && (
          <label className="aspect-square flex flex-col items-center justify-center gap-1 border-2 border-dashed border-slate-300 rounded-sm cursor-pointer hover:border-[#1E2A78] hover:bg-[#1E2A78]/5 transition-colors text-slate-500 hover:text-[#1E2A78]" data-testid="quote-photo-add">
            <ImagePlus className="h-6 w-6" />
            <span className="text-[11px] font-semibold">Add photos</span>
            <input type="file" accept="image/*" multiple className="hidden" onChange={(e) => { add(e.target.files); e.target.value = ""; }} data-testid="quote-photo-input" />
          </label>
        )}
      </div>
    </Step>
  );
}
